export default {
  title: "New features",
  "title-with-count":
    "Big update: We just launched 1 new feature. | Big update: We just launched {count} new features.",
  description: "Your favorite solar CRM has just been updated!",
  "action-label": "Learn more",
  "dismiss-label": "Dismiss",
  "changelog-label": "Changelog",
}
